// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LRVi","footer":"styles_footer__GGTVu","passCodeTooltip":"styles_passCodeTooltip__3zwgS"};